import {
    InputGroup,
    NumberInput as ChakraNumberInput,
    NumberInputField,
    NumberInputStepper,
    NumberIncrementStepper,
    NumberDecrementStepper,
} from '@chakra-ui/react';
import { useIntl } from 'react-intl';

const NumberInput = ({ placeholder, hasPercentage, hasStepperButtons = true, rightElement, leftElement, ...props }) => {
    const intl = useIntl();
    const defaultPlaceholder = intl.formatMessage({ id: 'common_select_number' });

    return (
        <InputGroup>
            {leftElement}
            <ChakraNumberInput w="100%" {...props}>
                <NumberInputField placeholder={placeholder ? placeholder : defaultPlaceholder} />

                {hasStepperButtons && (
                    <NumberInputStepper>
                        <NumberIncrementStepper />
                        <NumberDecrementStepper />
                    </NumberInputStepper>
                )}
            </ChakraNumberInput>
            {rightElement}
        </InputGroup>
    );
};

export default NumberInput;
